import { render, staticRenderFns } from "./ProposalSelection.vue?vue&type=template&id=2efdda31&"
import script from "./ProposalSelection.vue?vue&type=script&lang=js&"
export * from "./ProposalSelection.vue?vue&type=script&lang=js&"
import style0 from "./ProposalSelection.vue?vue&type=style&index=0&id=2efdda31&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports